export default __webpack_public_path__ + "static/media/jungle.49f93317.png";